module.exports = __webpack_public_path__ + "static/media/logo.6da17ac8.svg";